export var ALLOWED_ENVIRONMENTS = ['dev', 'prod', 'sanity', 'staging', 'unknown'];
export var ALLOWED_EVENTS = ['click', // form,
'submit', 'reset', 'change', // d&d
'dragend', 'drop', // media,
'ended', 'pause', 'play'];
export var ALLOWED_CORS_DOMAINS = [/api\.box\.com/, /api\.boxcn\.net/, /api\.boxenterprise\.net/, /api\.box-gov\.com/];
export var BOX_DOMAIN_NAMES = ['box.com', 'boxenterprise.net', 'boxcn.net', 'box-gov.com'];
export var FORCE_TRACING_HEADER = 'X-Box-Force-Tracing';